import { getParams } from "../../../../../../../../../src/modules/wizards/services";

export default {
    wizardType: "MYSQL",

    getJDBCURL: (m) => "jdbc:mysql://" + m.get("host") + ":" + m.get("port"),

    getConnectionParams: async (type, model) => getParams(type, model),
};

